/*
 * SPDX-FileCopyrightText: 2022 The HedgeDoc developers (see AUTHORS file)
 *
 * SPDX-License-Identifier: AGPL-3.0-only
 */
import { useApplicationState } from '../../../../hooks/common/use-application-state'
import React, { useMemo } from 'react'
import { Trans, useTranslation } from 'react-i18next'
/**
 * Renders a translated text that shows the number of lines in the document.
 */
export const WordCount: React.FC = () => {
  useTranslation()
  const markdownContent = useApplicationState((state) => state.noteDetails.markdownContent.plain)
  // const translationOptions = useMemo(() => ({ lines: markdownContent }), [markdownContent])
  const removeMetaData = (sanitizedMD: string) => {
    const metaStart = sanitizedMD.indexOf('---');
    const metaEnd = sanitizedMD.indexOf('---', metaStart + 3)
    if (metaEnd !== -1) {
      return sanitizedMD.slice(0, metaStart) + sanitizedMD.slice(metaEnd + 3, sanitizedMD.length);
    }
    return sanitizedMD
  }

  const sanitizeMD = (markdownContent) => {
    let sanitizedMD = markdownContent;
    sanitizedMD = removeMetaData(sanitizedMD);
    // remove next line
    sanitizedMD = sanitizedMD.replace(new RegExp('\n', 'g'), ' ');
    // remove tabs
    sanitizedMD = sanitizedMD.replace(new RegExp('\t', 'g'), ' ');
    // remove :::section{} Text ::: with just Text
    sanitizedMD = sanitizedMD.replace(new RegExp(/:::(.*?)#{2}\s(.*?):::/, "g"), '$2');
    // Remove Images
    sanitizedMD = sanitizedMD.replace(new RegExp(/!\[(.*?)]\((.*?)\)/, 'g'), '   ');
    // Remove HTML tags
    sanitizedMD = sanitizedMD.replace(new RegExp(/<(.*?)>/, 'g'), '');
    // Remove HTML Comments
    sanitizedMD = sanitizedMD.replace(new RegExp(/<!--(.*?)-->/, 'g'), '');
    // Remove Bullets
    sanitizedMD = sanitizedMD.replace(new RegExp(/\* \[(.*?)\]\(#(.*?)\)/, 'g'), '$1');
    // Remove Special Chars
    sanitizedMD = sanitizedMD.replace(new RegExp(/[#*`~\-–^=<>+|\/:]/, 'g'), '');
    // Remove extra spaces
    sanitizedMD = sanitizedMD.replace(new RegExp(/\s{2,}/, 'g'), ' ').trim();
    return sanitizedMD;
  }
  const calculateWordCount = () => {
    if (markdownContent.length === 0) {
      return 0;
    } else {
      const sanitizeString = useMemo(() => sanitizeMD(markdownContent) , [markdownContent]);
      return sanitizeString.split(" ").length
    }
  }

  return (
    <span>
      Word Count: {calculateWordCount()}
    </span>
  )
}
